export default function generateID() {
  return Math.floor(Date.now() * Math.random()).toString(36);
}
